import { all, takeEvery, put, call } from 'redux-saga/effects'
import exercisesApi from 'services/exercises'
import { actions } from './actions'

export function* loadExercises(topicId) {
  try {
    const response = yield call(exercisesApi.loadExercises, topicId.payload)

    yield put({
      type: actions.LOAD_EXERCISES_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_EXERCISES_RESULT,
      payload: { data: {} },
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_EXERCISES_REQUEST, loadExercises)])
}
